import {Component} from '@angular/core';

@Component({
			   selector   : 'app-ui-logo',
			   imports    : [],
			   templateUrl: './ui-logo.component.html',
			   styleUrl   : './ui-logo.component.css'
		   })
export class UiLogoComponent {

}
